
/**
 * @interface
 * @name Pattern
 * @extends Node
 * @property {Boolean} isPattern true
 */

/**
 * @interface
 * @name Assignable
 * @extends Node
 * @property {Boolean} isAssignable true
 */
